import { type ProspectNoteDto } from "@crowdcoursing/api/openapi";
import { PushPin } from "@mui/icons-material";
import { Box, IconButton, TextField, Tooltip } from "@mui/material";
import { Field, Form } from "react-final-form";

interface NoteFormValues extends Omit<ProspectNoteDto, "id" | "prospectId" | "createdAt" | "updatedAt"> {
  body: string;
  pinned: boolean;
}

interface NoteFormProps {
  initialValues?: Partial<NoteFormValues>;
  onSubmit: (values: NoteFormValues) => void;
}

export const NoteForm = ({ initialValues, onSubmit }: NoteFormProps) => {
  return (
    <Form<NoteFormValues>
      initialValues={{
        body: "",
        pinned: false,
        ...initialValues,
      }}
      onSubmit={onSubmit}
      render={({ handleSubmit }) => (
        <form id="note-form" onSubmit={handleSubmit}>
          <Box display="grid" gap={2}>
            {/* Content */}
            <Box display="flex" gap={1}>
              <Field name="body">
                {({ input }) => (
                  <TextField
                    {...input}
                    label="Note"
                    required
                    fullWidth
                    multiline
                    rows={3}
                    placeholder="Add a note..."
                  />
                )}
              </Field>

              {/* Pin Toggle */}
              <Field name="pinned" type="checkbox">
                {({ input: { value, onChange } }) => (
                  <Tooltip title={value ? "Unpin note" : "Pin note"}>
                    <IconButton
                      onClick={() => onChange(!value)}
                      color={value ? "primary" : "default"}
                      sx={{ alignSelf: "start", mt: 1 }}
                    >
                      <PushPin />
                    </IconButton>
                  </Tooltip>
                )}
              </Field>
            </Box>
          </Box>
        </form>
      )}
    />
  );
};
